import React from 'react';
import window from 'global';
import { LOGGER_TYPES } from '../../../LoggerFactory/loggerTypes';
import { wixDocsViewSourceClick } from '../../../LoggerFactory/BiAnalyticsLogger/events';
import { getArticleNameFromPathname } from '../../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { LoggerContext } from '../../../appContext/LoggerProvider';
import { StoreContext } from '../../../appContext/StoreProvider';
import { Button } from '../../Layout/Button';

interface SourceButtonProps {
  href: string;
}

export const SourceButton = ({ href }: SourceButtonProps) => {
  const { logger } = React.useContext(LoggerContext);
  const { store } = React.useContext(StoreContext);

  const sendViewSourceClickBiEvent = () => {
    logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsViewSourceClick, {
      article_name: getArticleNameFromPathname(window.location.pathname, store),
      article_url: window.location.href,
    });
  };

  return (
    <Button
      skin="secondary"
      onClick={sendViewSourceClickBiEvent}
      size="tiny"
      dataHook="source-link"
      as="a"
      target="_blank"
      href={href}
    >
      View Source
    </Button>
  );
};
